export function isDateValid(storedDateStr) {
    if (!storedDateStr)
        return false;
    const [day, month, year] = storedDateStr.split('/').map(Number);
    const storedDate = new Date(year, month - 1, day); // JS Date month is 0-indexed
    const today = new Date();
    const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    return storedDate >= currentDate;
}
export function onAnnualPlanSelect() {
    const destinationTypeCards = document.querySelectorAll('.destination-card');
    // if the card value is A or K, hide the card as they are not available for annual cover
    destinationTypeCards.forEach((card) => {
        if (card.value === 'A' || card.value === 'K') {
            card.closest('.destination-type').classList.add('hidden');
        }
    });
    // hide the end date container as it is not required for annual cover
    const endDateContainer = document.querySelector('.end-date__container');
    if (endDateContainer) {
        endDateContainer.classList.add('hidden');
    }
}
export function onAnnualPlanDeselect() {
    const destinationTypeCards = document.querySelectorAll('.destination-type');
    // show all the destination type cards
    destinationTypeCards.forEach((card) => {
        card.classList.remove('hidden');
    });
    // show the end date container
    const endDateContainer = document.querySelector('.end-date__container');
    if (endDateContainer) {
        endDateContainer.classList.remove('hidden');
    }
}
